import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
//import '../css/blog.css';
import { GetPostTags, getRandomLightColor } from '../services/apiservice';
import { useNavigate } from 'react-router-dom';
import Loader from './Loader';

const TagItems = (postSlugObject) => {
  const [postTags, setPostTags] = useState([]);
  // const navigate = useNavigate();
  // const handleBlogClick = () => navigate('/blog/:paramlink');

  const fillPostTags = async () => {
    try {
      const postTagsList = await GetPostTags(postSlugObject.postSlug);
      const jsonPostTagList = JSON.parse(postTagsList);
      setPostTags(jsonPostTagList);
      console.log("Post Tags:", jsonPostTagList);
      //setLoading(false);
    } catch (error) {
      console.error('Error fetching the data:', error);
    }
  }

  useEffect(() => {
    fillPostTags();
  }, []);

    const tagNames = postTags.map(tag => tag.tagname).join(', ');


  return (
    <>
     <div className="tag-section">
      <Helmet>
        {/* Standard meta tags */}
        <meta name="keywords" content={tagNames} />
        <meta property="article:tag" content={tagNames} />
        
      </Helmet>
      <div className="tag-item">
        {postTags.length > 0 ? (
          postTags.slice(0, 5).map((item, index) => (
            <span key={index} style={{ backgroundColor: getRandomLightColor(),borderRadius: "12px",padding: "5px 15px",marginRight: "20px" }}>
              <a href="#" className="no-underline">{item.tagname}</a>
              {/* <a href={"/blog/tag/" + item.paramlink} className="no-underline">{item.tagname}</a> */}
            </span>
          ))
        ) : (
          <></>
        )}

      </div>
       </div>
    </>
  );
};

export default TagItems;